import React from "react";

import { Stack } from "@chakra-ui/react";

import {
  QuestionTypeEnum,
  ReportFragment,
} from "../../../../graphql/generated/definitions";
import {
  QuestionFormMethods,
  QuestionWithAnswers,
} from "../../types/ReportFormTypes";

import QuestionText from "./QuestionText";
import QuestionSelectorMultiple from "./QuestionSelectorMultiple";
import QuestionSelectorSingle from "./QuestionSelectorSingle";

type QuestionFormDispatchProps = QuestionFormMethods & {
  question: QuestionWithAnswers;
  report: ReportFragment;
  path: `sections.${number}.answers.${number}`;
  sectionIndex: number;
  questionIndex: number;
};

const is = (q: QuestionWithAnswers, t: QuestionTypeEnum) => q.type === t;

const QuestionFormDispatch: React.FC<QuestionFormDispatchProps> = ({
  question,
  report,
  path,
  register,
  ...formMethods
}) => {
  return (
    <Stack spacing="5" className="avoid-page-break">
      {is(question, "QuestionText") && (
        <QuestionText
          {...{ question, report, path, register, ...formMethods }}
        />
      )}
      {is(question, "QuestionSelectorMultiple") && (
        <QuestionSelectorMultiple
          {...{ question, report, path, register, ...formMethods }}
        />
      )}
      {is(question, "QuestionSelectorSingle") && (
        <QuestionSelectorSingle
          {...{ question, report, path, register, ...formMethods }}
        />
      )}
      {is(question, "QuestionEvaluation") && (
        <QuestionSelectorSingle
          {...{ question, report, path, register, ...formMethods }}
        />
      )}
      {is(question, "QuestionSkill") && (
        <QuestionSelectorSingle
          {...{ question, report, path, register, ...formMethods }}
        />
      )}
    </Stack>
  );
};

export default React.memo(QuestionFormDispatch);
